import { Box, Flex, Text } from "@/ui";
import { AnimatePresence, motion } from "motion/react";
import { useDevices } from "@/store/devices";
import Lottie from "@/components/Lottie";
import AnimatedDot from "@/components/AnimatedDot";
import { useViewer } from "viewer/store/viewer";
import BatteryIndicator from "viewer/modules/station/components/BatteryIndicator";
import { getCurrentCameraConfig } from "viewer/store/viewer/selectors";
import { useIsPeerConnected } from "viewer/hooks/useIsPeerConnected";
import motionAnim from "assets/animations/motion.json?url";
import noiseAnim from "assets/animations/noise.json?url";

export default function CameraInfo() {
  const devices = useDevices((state) => state.devices);
  const previews = useViewer((state) => state.cameraPreviews);
  const cameraConfig = useViewer(getCurrentCameraConfig);
  const connected = useIsPeerConnected(cameraConfig?.jid);

  if (!cameraConfig) return null;

  const deviceName = devices[cameraConfig.jid]?.name;
  const isCharging = previews[cameraConfig.jid]?.status?.batteryStatus?.state === "CHARGING";
  const currentEvents = previews[cameraConfig.jid]?.status?.currentEvents || [];
  const avaiableBatteryStatus = cameraConfig.batteryStatus?.state !== "UNKNOWN";

  const hasAnyEvents = currentEvents.length > 0;
  return (
    <Box pos="absolute" bottom="32" right="32" zIndex={2}>
      <Flex pos="relative" h="24px" columnGap="6px" alignItems="center">
        <AnimatePresence>
          {currentEvents.map(({ type }) => (
            <motion.div
              layout
              key={type}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              transition={{ duration: 0.3 }}
            >
              <Lottie src={type === "MOTION" ? motionAnim : noiseAnim} props={{ w: "24" }} />
            </motion.div>
          ))}
          {connected && !hasAnyEvents && <AnimatedDot />}
        </AnimatePresence>
        <Flex align="center" columnGap="6px">
          <Text
            variant="label"
            color="neutral-variant.99"
            maxW="20vw"
            whiteSpace="nowrap"
            overflow="hidden"
            textOverflow="ellipsis"
          >
            {deviceName}
          </Text>
          {!isCharging && avaiableBatteryStatus && connected && (
            <BatteryIndicator batteryLevel={cameraConfig.batteryStatus.level} />
          )}
        </Flex>
      </Flex>
    </Box>
  );
}
